import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LogOut } from 'lucide-react';
import { ConsumerLayout } from '@/components/consumer/ConsumerLayout';
import { ConsumerAvatarCard } from '@/components/consumer/ConsumerAvatarCard';
import { ConsumerDadosPessoaisCard } from '@/components/consumer/ConsumerDadosPessoaisCard';
import { useAuthContext } from '@/contexts/AuthContext';

/**
 * Perfil do cliente: foto (avatar + bottom sheet) + Dados Pessoais (mesmo modelo
 * do prestador: nome, email, telefone, endereço) + Sair.
 */
export default function ConsumerPerfil() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { signOut } = useAuthContext();

  const handleSignOut = async () => {
    await signOut();
    navigate('/auth', { replace: true });
  };

  return (
    <ConsumerLayout hideHeader>
      <ConsumerAvatarCard />
      <ConsumerDadosPessoaisCard />

      <div className="max-w-md mx-auto w-full mt-6">
        <button
          type="button"
          onClick={handleSignOut}
          className="ow-btn ow-btn--ghost ow-btn--block text-destructive"
        >
          <LogOut className="h-4 w-4 mr-2" />
          {t('consumer.nav.signOut')}
        </button>
      </div>
    </ConsumerLayout>
  );
}
